/* eslint-disable @typescript-eslint/no-explicit-any */
import { CSSProperties, ReactNode, useCallback, useRef } from 'react';

import { Box } from '@aicon-dev/caas-core';
import { CloseOutline } from 'antd-mobile-icons';
import QuickPinchZoom, { make3dTransformValue } from 'react-quick-pinch-zoom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { useLocationState } from '~/libs/hooks/useLocationState';

import { UploadFileResponse } from '../Upload';

import { header, mask } from './styles.css';

interface IImageProps {
  image: Partial<UploadFileResponse>;
  imageStyle: CSSProperties;
  renderCustomPreview?: (openViewer: () => void) => ReactNode;
}

export const ImagePinchZoom = ({ image, imageStyle, renderCustomPreview }: IImageProps) => {
  const [isImageViewer, setIsImageViewer] = useLocationState(false);
  const navigate = useNavigate();

  const handleClickViewerOpen = () => {
    setIsImageViewer(true);
    document.body.style.overflow = 'hidden';
  };

  const handleClickViewerClose = () => {
    navigate(-1);
    document.body.style.overflow = 'unset';
  };

  const imgRef = useRef(null);
  const onUpdate = useCallback(({ x, y, scale }: any) => {
    const { current: img }: any = imgRef;

    if (img) {
      const value = make3dTransformValue({ x, y, scale });

      img.style.setProperty('transform', value);
    }
  }, []);

  return (
    <>
      {isImageViewer ? (
        <div onClick={handleClickViewerClose}>
          <div className={mask}>
            <Wrapper>
              <div className={header}>
                <Box p="12px">
                  <CloseOutline color="white" fontSize="20px" />
                </Box>
              </div>

              <QuickPinchZoom onUpdate={onUpdate} key={image?._id}>
                <div
                  ref={imgRef}
                  style={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100vw',
                    height: '100dvh',
                  }}
                >
                  <img src={image.url} style={{ width: '100vw', background: 'var(--white)' }} />
                </div>
              </QuickPinchZoom>
            </Wrapper>
          </div>
          {renderCustomPreview ? (
            renderCustomPreview(handleClickViewerOpen)
          ) : (
            <img key={image?._id} src={image.url} style={imageStyle} />
          )}
        </div>
      ) : renderCustomPreview ? (
        renderCustomPreview(handleClickViewerOpen)
      ) : (
        <img key={image?._id} src={image.url} style={imageStyle} onClick={handleClickViewerOpen} />
      )}
    </>
  );
};

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
